import { LocalKey } from "@base/constants/LocalKey";
import { baseRoutes } from "@base/routes/routePaths";
import { createSearchParams, Navigate, Outlet, useLocation } from "react-router-dom";

/**
 * Gate for routes that need a session. Anonymous visitors are sent to the login screen with a
 * `redirectTo` pointing back at what they were trying to reach - the same contract useCheckLogin
 * uses, so useAuth can send them there after a successful login.
 */
export default function ProtectedRoute() {
  const location = useLocation();

  if (localStorage.getItem(LocalKey.AUTH)) {
    return <Outlet />;
  }

  return (
    <Navigate
      to={{
        pathname: baseRoutes.login,
        search: createSearchParams({ redirectTo: `${location.pathname}${location.search}` }).toString(),
      }}
      replace
    />
  );
}
